

export default class ParametroConsultaAutorizaciones {

    constructor() {
        this.Identificacion = "";
        this.TipoPersona = null;
        this.FechaTramiteDesde = "";
        this.FechaTramiteHasta = "";
        this.NumeroAutorizacion = "";
        this.TipoAutorizacion = null;
        this.EntidadAutorizada = "";
        this.UsuarioTramiteIdentificacion = "";
    }

    Identificacion: string;
    TipoPersona: any;
    FechaTramiteDesde: string;
    FechaTramiteHasta: string;
    NumeroAutorizacion: string;
    TipoAutorizacion: any;
    EntidadAutorizada: string;
    UsuarioTramiteIdentificacion: string;
}